export const getPersonalDetails = (state) => state.personalDetails;